import { Controller } from "stimulus";

// Sorts the table body by a clicked column header. Rows carry their raw sort
// values as data-sort-<key> attributes, since displayed values may be
// rounded or formatted.
export default class extends Controller {
  static targets = ["body", "header"];

  sort(event) {
    const button = event.currentTarget;
    const header = button.closest("th");
    const key = button.dataset.sortKey;
    const numeric = button.dataset.sortType === "number";

    // Numbers start high to low, text A to Z, then each click flips it
    const current = header.getAttribute("aria-sort");
    const ascending = current ? current !== "ascending" : !numeric;

    this.headerTargets.forEach((th) => th.removeAttribute("aria-sort"));
    header.setAttribute("aria-sort", ascending ? "ascending" : "descending");

    const valueOf = (row) => {
      const value = row.getAttribute(`data-sort-${key}`);
      return numeric ? Number(value || -1) : value.toLowerCase();
    };

    Array.from(this.bodyTarget.rows)
      .sort((a, b) => {
        const [x, y] = [valueOf(a), valueOf(b)];
        const order = x < y ? -1 : x > y ? 1 : 0;
        return ascending ? order : -order;
      })
      .forEach((row) => this.bodyTarget.appendChild(row));
  }
}
